"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const BaseColumns_1 = __importDefault(require("../BaseColumns"));
function ColumnsGrouping({ columnDefinitions, styles, onGroupChange, groupBy, }) {
    return (react_1.default.createElement(BaseColumns_1.default, { title: "Group by", columnDefinitions: columnDefinitions, styles: styles, onColumnChange: onGroupChange, columns: groupBy }));
}
exports.default = ColumnsGrouping;
//# sourceMappingURL=index.js.map